export enum Permission {
  LoyaltyProgramInternalView = 'loyalty_program_internal.view',
  LoyaltyProgramInternalModify = 'loyalty_program_internal.modify',
  LoyaltyProgramView = 'loyalty_program.view',
  LoyaltyProgramModify = 'loyalty_program.modify',
}
